import * as Adyen from '@reverbdotcom/adyen-cse-js';
import * as moment from 'moment';
import AppConfigStore from '../reverb-js-common/app_config_store';

const TOKENIZATION_PARAMS = [
  'number',
  'cvc',
  'holderName',
  'expiryMonth',
  'expiryYear',
];

// our expiration year input is 2 numbers but adyen wants 4 for tokenization
const formatExpirationYear = (yearString) => {
  const date = moment(yearString, 'YY');
  return date.format('YYYY');
};

// according to adyen this should be generated server-side
const generationTime = () =>
  new Date().toISOString();

const formattedTokenizationData = (data) => {
  const formattedData: any = {};

  TOKENIZATION_PARAMS.forEach((key) => {
    if (data[key]) {
      if (key === 'expiryYear' && data[key].length === 2) {
        formattedData[key] = formatExpirationYear(data[key]);
      } else {
        formattedData[key] = data[key];
      }
    }
  });

  formattedData.generationtime = generationTime();

  return formattedData;
};

const options = {};

const tokenizeCard = (creditCardData) => {
  const { adyenClientEncryptionPublicKey } = AppConfigStore.getState();
  const adyen = Adyen.createEncryption(adyenClientEncryptionPublicKey, options);
  return adyen.encrypt(formattedTokenizationData(creditCardData));
};

export default { tokenizeCard };

export { tokenizeCard };
